import { render } from "./ImageViewerSettings.vue?vue&type=template&id=14260288&scoped=true&ts=true"
import script from "./ImageViewerSettings.vue?vue&type=script&lang=ts"
export * from "./ImageViewerSettings.vue?vue&type=script&lang=ts"

import "./ImageViewerSettings.vue?vue&type=style&index=0&id=14260288&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14260288"]])

export default __exports__